/*****************************************

jQuery.ccl_tab
version 2.0
Hiroshi Fukuda <dada@sygnas.jp>
http://sygnas.jp/

The MIT License

Copyright (c) 2011-2012 Hiroshi Fukuda, http://sygnas.jp/

/*****************************************


/*****************************************

タブナビゲーションを実装。
・data-ccltab-content 属性でターゲットとなるコンテンツを指定
・data-ccltab-hash 属性でURLのハッシュを変更するかを指定
・data-ccltab-prev 属性で戻るボタンのエレメントを指定
・data-ccltab-next 属性で進むボタンのエレメントを指定
・表示エフェクトに関しては全てcssにて行う。
・非表示状態についてもcssで定義する。
・タブボタンのリンクで指定するのは #{数字}
・アクティブなタブには data-ccltab-active="true" が付く
・アクティブなコンテンツには data-ccltab-show="true" が付く

= example =

<ul class="js-ccltab_tab" data-ccltab-content=".js-ccltab_content" data-ccltab-hash="true">
    <li><a href="#0">PROFILE</a></li>
    <li><a href="#1">DISCOGRAPHY</a></li>
</ul>

<div class="js-ccltab_content">コンテンツ 0</div>
<div class="js-ccltab_content">コンテンツ 1</div>

<script>
var CaracolTab = require('./caracol/navigation/jquery.tab.js');
new CaracolTab('.js-ccltab_tab');
</script>


*****************************************/

/*****************************************

2016.11.29 ver 2.0
	・アクティブ指定は data属性を使うように変更
	・prev / next に対応

2016.07.15 ver 1.0
	・とりあえず作成

*****************************************/

var CaracolTab;

module.exports = CaracolTab = function( target ){
	'use strict';

	// 個々のタブでインスタンスを作成
	$(target).each( function(){
		new TabControllClass( this );
	});

	/****************************
	* tab control class
	*/
	function TabControllClass( target ){
		'use strict';

		var $tab = $(target);
		var $tab_buttons = $tab.find('a');
		var $contents = $( $tab.data('ccltab-content') );
		var $prev = $tab.data('ccltab-prev') ? $( $tab.data('ccltab-prev') ) : null;
		var $next = $tab.data('ccltab-next') ? $( $tab.data('ccltab-next') ) : null;
		var config = {
			hash: $tab.data('ccltab-hash') === true ? true : false
		};
		// 現在アクティブなコンテンツ
		var now = null;

		// 最初のタブをアクティブに
		check_url_hash();

		// タブをクリックした
		$tab.find('a').on('click', function(){
			var index = this.hash.substr(1);
			set_active_from_index( index );
			return false;
		});

		// prev / next をクリックした
		if( $prev ){
			$prev.on('click', function(){
				var index = Math.min( now + 1, $contents.length - 1 );
				set_active_from_index( index );
			});
		}

		if( $next ){
			$next.on('click', function(){
				var index = Math.max( now - 1, 0 );
				set_active_from_index( index );
			});
		}

		// 指定した index のタブをアクティブにする
		function set_active_from_index( index ){
			'use strict';

			// タブとコンテンツにアクティブ属性付与
			if( now !== null ){
				$tab_buttons.eq(now).attr('data-ccltab-active', '');
				$contents.eq(now).attr('data-ccltab-show', '');
			}
			$tab_buttons.eq(index).attr('data-ccltab-active', 'true');
			$contents.eq(index).attr('data-ccltab-show', 'true');

			// URLにハッシュ付与
			if( config.hash ){
				window.location.hash = index;
			}
			now = index;
		}

		// 登録時にURLハッシュをチェックする
		function check_url_hash(){
			'use strict';

			if( config.hash ){
				var hash = window.location.hash.substr(1);

				// ハッシュが番号だったら該当コンテンツを開く
				if( !isNaN(hash) && hash.length ){
					set_active_from_index(hash);
					return;
				}
			}
			// デフォルトでは最初のコンテンツをアクティブにする
			set_active_from_index(0);
		}
	}
};




/*****************
 ** WEBPACK FOOTER
 ** /Users/dada/www/_template/.src/js/caracol2.0.0/navigation/tabs.js
 ** module id = 4
 ** module chunks = 0
 **/